import { ErrorCodes } from 'enums';

export class RoleNotFoundError extends Error {
  code: ErrorCodes = ErrorCodes.ROLE_NOT_FOUND;

  constructor() {
    super('Usuário não tem permissão para acessar este recurso.');
    this.name = 'RoleNotFoundError';

    return this;
  }
}
